module.exports = __webpack_public_path__ + "media/images/landing/tnc_banner-19562a7b726434e5eb278217cf476b62.jpg";